export default __webpack_public_path__ + "static/media/eng-feedback.82755bef.jpg";